import { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
import './PortfolioPage.css';

export default function PortfolioPage() {
  pageTitle('Portfolio');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Portfolio items (images + videos)
  const portfolioItems = [
    { type: 'image', src: './images/portfolio/1.jpeg', title: 'Website Design' },
    { type: 'video', src: 'https://www.youtube.com/embed/j5i--kxqjv8', title: 'Brand Promotion Video' },
    { type: 'image', src: './images/portfolio/2.jpeg', title: 'Creative Campaign' },
    { type: 'image', src: './images/portfolio/3.jpeg', title: 'Corporate Website' },
    { type: 'image', src: './images/portfolio/4.jpeg', title: 'Mobile App UI Design' },
        { type: 'image', src: './images/portfolio/4.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/5.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/6.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/7.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/8.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/9.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/10.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/11.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/12.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/13.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/14.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/15.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/16.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/17.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/18.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/19.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/20.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/21.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/22.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/23.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/24.jpeg', title: 'Mobile App UI Design' },
        { type: 'image', src: './images/portfolio/25.jpeg', title: 'Mobile App UI Design' },
    { type: 'image', src: './images/portfolio/26.jpeg', title: 'Mobile App UI Design' },


  ];

  return (
    <>
      {/* ======= Breadcrumb ======= */}
      <Breadcrumb title="Our Portfolio" bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg" />

      {/* ======= Portfolio Section ======= */}
  <Section pt="100" ptLg="75" pb="100" pbLg="55">
  <div className="container">


    {/* ======= Portfolio Grid ======= */}
    <div className="portfolio-grid">
      {portfolioItems.map((item, index) => (
        <div className="portfolio-item" key={index}>
          {item.type === 'image' ? (
            <img src={item.src} alt={item.title} className="portfolio-media" />
          ) : (
            <div className="iframe-wrapper">
              <iframe
                src={`${item.src}?autoplay=0&mute=1&rel=0&modestbranding=1`}
                title={item.title}
                allow="autoplay; encrypted-media; picture-in-picture"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          )}
          {/* <h4 className="portfolio-item-title">{item.title}</h4>
          <p className="portfolio-item-description">
            {item.description || "Professional solar installation ensuring energy efficiency, durability, and long-term performance."}
          </p> */}
        </div>
      ))}
    </div>

    {/* ======= Bottom Heading ======= */}
    <div className="bottom-heading text-center mt-5">
      <h3>Power Your Future with Solar Energy</h3>
      <p>Work with Riyansh Solar Power Plus to create sustainable energy solutions for homes, businesses, and industries.</p>
      <a href="/contact" className="btn btn-primary mt-3">Request a Consultation</a>
    </div>
  </div>
</Section>

    </>
  );
}
